import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { Dayjs } from "dayjs";
import { MealName, MealNameToOrder, State, StateProps } from "./state";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { MenuItem as MuiMenuItem } from "@mui/material";

export function getMenuKey(selectedDate: string, mealName: MealName | string) {
  return `${selectedDate}-${mealName}`;
}
function onDateClick(
  dateTime: Dayjs | null,
  state: State,
  setState: React.Dispatch<React.SetStateAction<State>>,
) {
  const selectedDate = dateTime?.toISOString();
  const mealName = state.selectedMealName;
  if (selectedDate) {
    const menuKey = getMenuKey(selectedDate, mealName);
    setState((prevState: State) => {
      const updatedMenu = Object.fromEntries(
        Object.entries(prevState.menu).map(([date, menuItem]) => [
          date,
          { ...menuItem, selected: false },
        ]),
      );
      updatedMenu[menuKey] = {
        ...updatedMenu[menuKey],
        date: new Date(selectedDate),
        mealName,
        mealOrder: state.settings
          ? state.settings.meals.indexOf(mealName)
          : (MealNameToOrder[mealName as MealName] ?? 0),
        selected: true,
      };
      return {
        ...prevState,
        menu: updatedMenu,
        openModals: {
          ...prevState.openModals,
          recipeBook: true,
        },
      };
    });
  }
}

export interface MealSelctionOptions extends StateProps {}

export default function MealSelction(options: MealSelctionOptions) {
  const handleMealNameSelectChange = (event: SelectChangeEvent) => {
    options.setState((prevState: State) => {
      return {
        ...prevState,
        selectedMealName: event.target.value,
      };
    });
  };
  return (
    <>
      <Accordion
        defaultExpanded={options.state.settings?.mealsExpanded ?? false}
      >
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          aria-controls="mealSelection-content"
          id="mealSelection-header"
        >
          <Typography component="span">Meal Selection</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar
              onChange={(x) => onDateClick(x, options.state, options.setState)}
              showDaysOutsideCurrentMonth
            />
          </LocalizationProvider>
          <FormControl fullWidth>
            <InputLabel id="meal-name-select-label">Meal Name</InputLabel>
            <Select
              labelId="meal-name-select-label"
              id="meal-name-select"
              value={options.state.selectedMealName}
              label="meal-name"
              onChange={handleMealNameSelectChange}
            >
              {(
                options.state.settings?.meals ?? Object.keys(MealNameToOrder)
              ).map((meal) => {
                return <MuiMenuItem value={meal}>{meal}</MuiMenuItem>;
              })}
            </Select>
          </FormControl>
        </AccordionDetails>
      </Accordion>
    </>
  );
}
